import api from './api';

export const getDocuments = async (params = {}) => {
  const response = await api.get('/documents', { params });
  return response.data;
};

export const getDocument = async (id) => {
  const response = await api.get(`/documents/${id}`);
  return response.data;
};

export const createDocument = async (documentData) => {
  const formData = new FormData();
  
  Object.keys(documentData).forEach((key) => {
    if (key === 'attachments' && Array.isArray(documentData[key])) {
      documentData[key].forEach((file, index) => {
        formData.append(`attachments`, file);
      });
    } else if (documentData[key] !== null && documentData[key] !== undefined) {
      if (typeof documentData[key] === 'object') {
        formData.append(key, JSON.stringify(documentData[key]));
      } else {
        formData.append(key, documentData[key]);
      }
    }
  });

  const response = await api.post('/documents', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const updateDocument = async (id, documentData) => {
  const formData = new FormData();
  
  Object.keys(documentData).forEach((key) => {
    if (key === 'attachments' && Array.isArray(documentData[key])) {
      documentData[key].forEach((file) => {
        if (file instanceof File) {
          formData.append(`attachments`, file);
        }
      });
    } else if (documentData[key] !== null && documentData[key] !== undefined) {
      if (typeof documentData[key] === 'object' && !(documentData[key] instanceof File)) {
        formData.append(key, JSON.stringify(documentData[key]));
      } else {
        formData.append(key, documentData[key]);
      }
    }
  });

  const response = await api.put(`/documents/${id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const deleteDocument = async (id) => {
  const response = await api.delete(`/documents/${id}`);
  return response.data;
};

export const assignDocument = async (id, userIds, notes = '') => {
  const response = await api.post(`/documents/${id}/assign`, {
    userIds,
    notes,
  });
  return response.data;
};

export const updateDocumentStatus = async (id, status) => {
  const response = await api.put(`/documents/${id}/status`, { status });
  return response.data;
};

export const downloadAttachment = async (documentId, attachmentId) => {
  const response = await api.get(`/documents/${documentId}/attachments/${attachmentId}/download`, {
    responseType: 'blob',
  });
  return response.data;
};

export const previewDocument = async (documentId, attachmentId) => {
  const response = await api.get(`/documents/${documentId}/attachments/${attachmentId}/preview`);
  return response.data;
};

export const getDocumentStats = async () => {
  const response = await api.get('/documents/stats');
  return response.data;
};
